import {
  Grid,
  Radio,
  Typography,
  createStyles,
  makeStyles,
} from '@material-ui/core';
import { DefaultCard } from 'design-system';
import React, { useMemo } from 'react';

import { THIRD_PARTY_PACK } from 'data-layer-cr/dist/constants/products';
import {
  regularCoverages,
  specialCoverages,
} from 'data-layer-cr/dist/functions/coverages';
import {
  defaultUnit,
  getRegularCoverages,
} from 'data-layer-cr/dist/functions/quotations';
import {
  CoverageCatalog,
  CoverageCatalogResume,
  Quotation,
} from 'data-layer-cr/dist/models';

// Components
import PricingProfileResponse from '../../../../../models/responseTypes/PricingProfileResponse';
import CoverageDetailList from '../../components/CoverageDetailList';

type Props = {
  quotation: Quotation;
  coverages: CoverageCatalog[];
  coverageResumes: CoverageCatalogResume[];
  currentProfile?: PricingProfileResponse;
};

const useStyles = makeStyles(() =>
  createStyles({
    titleFontSize: {
      fontSize: '19px',
      fontWeight: 900,
    },
  }),
);

const CoverageDetailsCard = ({
  quotation,
  coverages,
  coverageResumes,
  currentProfile,
}: Props): JSX.Element => {
  const completeCoverages = regularCoverages(coverages);

  // Coverage values comming from the quotation
  const simplifiedCoverageList = useMemo(
    () => getRegularCoverages(quotation, coverageResumes),
    [quotation, coverageResumes],
  );

  const unit = useMemo(() => defaultUnit(quotation), [quotation]);

  const classes = useStyles();

  const packageName: React.ReactNode = (
    <Grid container style={{ marginBottom: 12 }}>
      <img
        src="/svg/coverage_shield.svg"
        alt="coverage Shield"
        style={{ marginRight: 11 }}
      />
      <Typography className={classes.titleFontSize}>Coberturas</Typography>
    </Grid>
  );

  return (
    <DefaultCard title={packageName}>
      <Grid container>
        {quotation.productId === THIRD_PARTY_PACK && (
          <Grid
            data-testid="selected-package"
            item
            xs={12}
            container
            alignItems="center"
          >
            <Radio checked />
            &nbsp;
            <Typography variant="body1">{unit.package.description}</Typography>
          </Grid>
        )}
        <Grid item xs={12}>
          <CoverageDetailList
            hideNotFound
            specialCoverages={specialCoverages(coverages)}
            coverages={completeCoverages}
            simplifiedCoverages={simplifiedCoverageList}
            currentProfile={currentProfile as PricingProfileResponse}
          />
        </Grid>
      </Grid>
    </DefaultCard>
  );
};

export default CoverageDetailsCard;
